export default "__VITE_ASSET__Bt$CM$Vu__"